export default "../../src/img/payment.webp";